import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import type { Item } from '#domains/items';
import type { IconName } from '#shared/components';

dayjs.extend(relativeTime);

const prepareMetadata = (item: Item) => {
  const url = new URL(item.url ?? 'http://none');
  const { hostname } = url;

  const date = dayjs(item.createdAt);

  const createdAt = date.fromNow();
  const createdAtTitle = date.format('MMM D, YYYY h:mm A');

  let iconName: IconName = 'circle';

  if (item.type === 'bookmark') {
    iconName = 'bookmark';
  }

  return { iconName, hostname, createdAt, createdAtTitle };
};

export default prepareMetadata;
